import { AppState } from "../../../redux/reducers";

// store
import * as ContractConceptRelationShipStore from "../../../redux/middleware/ContractConceptRelationship.Middleware";
import { ContractConceptConcept_Add_Receive_Action } from "../../../redux/actions/ContractConceptConcept.Actions";
import { ContractConceptRelationship } from "../../../models/Entities/Contracts/ContractConceptRelationship";
import { ErrorType } from "../../../models/HttpError";

interface IProps {
  ContractId: number;
}

interface ConnectedProps {
  isLoading: boolean;
  LoadingSuccess: boolean;
  failLoading: boolean;
  error: ErrorType | undefined;
  concepts: ContractConceptRelationship[];
  isDeleting?: boolean;
  successDeleting?: boolean;
}

interface ComponentDispatchProps {
    getAllContractConceptRelationships: typeof ContractConceptRelationShipStore.actionCreators.getAllContractConceptRelationships;
    createContractConceptRelationship: typeof ContractConceptRelationShipStore.actionCreators.createContractConceptRelationship;
    deleteContractConceptRelationship: typeof ContractConceptRelationShipStore.actionCreators.deleteContractConceptRelationship;
}

export type Props = IProps & ConnectedProps & ComponentDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isLoading: state.ContractConceptRelationship?.isLoadingAll ?? false,
    LoadingSuccess: state.ContractConceptRelationship?.successLoadingAll ?? false,
    failLoading: state.ContractConceptRelationship?.failOnLoadingAll ?? false,
    error: state.ContractConceptRelationship?.error,
  concepts: state.ContractConceptRelationship?.list ?? [],
  isDeleting: state.ContractConceptRelationship?.isDeletingOne ?? false,
  successDeleting: state.ContractConceptRelationship?.successDeletingOne ?? false,
    
});

export const mapDispatchToProps = {
  ...ContractConceptRelationShipStore.actionCreators
};